import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppointmentRequestQuery } from '@warema/shared/models';
import { Observable } from 'rxjs';
import * as AppointmentMetadataActions from '../state/appointment-metadata.actions';
import { AppointmentMetadataState } from '../state/appointment-metadata.reducer';
import * as AppointmentMetadataSelectors from '../state/appointment-metadata.selectors';
@Injectable({
    providedIn: 'root',
})
export class AppointmentMetadataService {
    private readonly _store = inject<Store<AppointmentMetadataState>>(Store);

    public appointmentRequestQueryId$: Observable<string | null>;

    constructor() {
        this.appointmentRequestQueryId$ = this._store.select(
            AppointmentMetadataSelectors.selectAppointmentRequestQueryId,
        );
    }

    public setAppointmentRequestQuery(appointmentRequestQuery: AppointmentRequestQuery): void {
        this._store.dispatch(AppointmentMetadataActions.SetAppointmentRequestQuery({ appointmentRequestQuery }));
    }
}
